import NotFound from '../components/Shared/NotFound/NotFound.vue'
import { UsuarioRoutes } from '../components/Usuario/Rotas/Routes'
import { HomeRoutes } from '../components/Home/Rotas/Routes'
import { FinanceiroRoutes } from '../components/Financeiro/Rotas/Routes'
import { EstoqueRoutes } from '../components/Estoque/Rotas/Routes'
import { CarrinhoRoutes } from '../components/Carrinho/Rotas/Routes'
import { AlimentoRoutes } from '../components/Alimento/Rotas/Routes'
import { CadastroRoutes } from "../components/Cadastro/Rotas/Routes";
import { VendaRoutes } from "../components/Venda/Rotas/Routes";


export const routes = [{ path: '*', component: NotFound }].concat(
    UsuarioRoutes,
    HomeRoutes,
    FinanceiroRoutes,
    EstoqueRoutes,
    CarrinhoRoutes,
    AlimentoRoutes,
    CadastroRoutes,
    VendaRoutes
);

// for (let i = 0; i < UsuarioRoutes.length; i++) {
//   routes.push(UsuarioRoutes[i]);
// }
// for (let i = 0; i < HomeRoutes.length; i++) {
//   routes.push(HomeRoutes[i]);
// }
// for (let i = 0; i < FinanceiroRoutes.length; i++) {
//   routes.push(FinanceiroRoutes[i]);
// }
// for (let i = 0; i < EstoqueRoutes.length; i++) {
//   routes.push(EstoqueRoutes[i]);
// }
// for (let i = 0; i < CarrinhoRoutes.length; i++) {
//   routes.push(CarrinhoRoutes[i]);
// }
// for (let i = 0; i < AlimentoRoutes.length; i++) {
//   routes.push(AlimentoRoutes[i]);
// }
// for (let i = 0; i < CadastroRoutes.length; i++) {
//   routes.push(CadastroRoutes[i]);
// }
// for (let i = 0; i < VendaRoutes.length; i++) {
//   routes.push(VendaRoutes[i]);
// }


// WEBPACK FOOTER //
// ./src/router/Routes.js